module.exports = __webpack_public_path__ + "r-v3/img/preview_gooroomee_name.3b84c38c.svg";